/* eslint-disable no-async-promise-executor */
import customProtocolDetection from 'custom-protocol-detection';
import MobileDetect from 'mobile-detect';

export const platform = () => {
  const md = new MobileDetect(window.navigator.userAgent);
  const phone = md.phone();
  const isIOS = md.is('iphone');

  const result = {
    platform: '',
    browser: md.userAgent(),
  };

  if (!phone) {
    result.platform = 'pc';
  } else if (!isIOS) {
    result.platform = 'android';
  } else {
    result.platform = 'ios';
  }
  return result;
};

// 判断Connex
export const checkIsConnex = () => window.connex;

// 判断当前环境
export const checkNode = async (parentId) => {
  const block = window.connex.thor.block(0);
  const firstBlock = await block.get();
  return firstBlock?.id === parentId;
};

export const checkProtocolDetection = async (config) => {
  if (!checkIsConnex()) {
    const getPlatform = platform();
    let targetUrl = `${config.getIn(['openURI', getPlatform.platform])}${encodeURIComponent(config.get('node'))}/${encodeURIComponent(window.location.href)}`;
    if (getPlatform.platform !== 'pc') {
      targetUrl = `${config.getIn(['openURI', getPlatform.platform])}=${encodeURIComponent(window.location.origin)}`;
    }
    let redirectUrl = `${config.getIn(['downloadURI', getPlatform.platform])}${encodeURIComponent(config.get('node'))}/${encodeURIComponent(window.location.href)}`;
    if (getPlatform.platform !== 'pc') {
      redirectUrl = `${config.getIn(['downloadURI', getPlatform.platform])}`;
    }
    return new Promise((resolve) => {
      customProtocolDetection(`${targetUrl}`,
        () => resolve(redirectUrl),
        () => {
        // 调起应用成功回调
          setTimeout(() => {
            const frame = document.querySelector('#hiddenIframe');
            const contentDocument = frame && frame.contentDocument;
            if (frame === null || contentDocument !== null) {
              return resolve(redirectUrl);
            }
            return resolve(redirectUrl);
          }, 1000);
        }, () => {
          window.location.href = targetUrl;
          setTimeout(() => resolve(redirectUrl), 1000);
        });
    });
  }
  if (await checkNode(config.get('parentId'))) {
    return 'next';
  }
  return 'break';
};

export const addressFormat = (address, len = 4) => `${address.slice(0, 2 + len)}****${address.slice(-len, address.length)}`;

// 判断网络时候连接
export const isOnLine = () => window.navigator.onLine;
